module.exports = __webpack_public_path__ + "static/media/ETKC2.1c7ba250.png";